import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import Loading from '../../components/loading';
import ErrorMessage from '../../components/errorMessage';
import { useCreateNps } from './hooks/useCreateNps';

export default function NpsModal({ open, onClose, onSaveSuccess }) {
  const { create: createNps } = useCreateNps();
  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (open) {
      setShowErrorMessage(false);
      setLoading(false);
    }
  }, [open]);

  const createSurvey = () => {
    setLoading(true);
    createNps()
      .then((returnFromApi) => {
        onSaveSuccess(returnFromApi);
        setLoading(false);
      })
      .catch((returnFromApi) => {
        setShowErrorMessage(true);
        setErrorMessage(returnFromApi.response?.data || 'Erro ao criar pesquisa.');
        console.error('Erro ao criar pesquisa NPS:', returnFromApi);
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Loading isToHidden={isLoading === false} />
      {showErrorMessage && (
        <ErrorMessage
          message={errorMessage}
          show={showErrorMessage}
          setShow={setShowErrorMessage}
        />
      )}

      <DialogTitle>Criar Nova Pesquisa</DialogTitle>

      <DialogContent dividers>
        <Typography>
          A pesquisa será criada e exibida para os usuários de acordo com as configurações definidas
          no sistema.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={createSurvey} disabled={isLoading}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

NpsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaveSuccess: PropTypes.func.isRequired,
};
